
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.633 7.465l-3.719 3.719a.653.653 0 01-.927 0l-.617-.618a.654.654 0 010-.927l2.635-2.636L1.37 4.367a.654.654 0 010-.927l.615-.624a.654.654 0 01.927 0l3.718 3.72c.26.256.26.672.003.929z","fill":"#348EF6"}})])
          )
        }
      }
    